
import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { BadRequestHandler, GlobalMessageService, GlobalMessageType, HttpResponseStatus } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { GenErrorHandleService } from '../services/error-handle.service';
import { genTranslationsEn } from 'src/assets/i18n/gen-translations';
import { findLimitedAvailabilityCheckoutError } from '../utils/limited-availability.utils';

@Injectable({
  providedIn: 'root',
})
export class GenBadRequestHandler extends BadRequestHandler implements OnDestroy {
  override responseStatus = HttpResponseStatus.BAD_REQUEST;
  subscriptions = new Subscription();

  constructor(
    private errorHandleService: GenErrorHandleService,
    protected override globalMessageService: GlobalMessageService
  ) {
    super(globalMessageService);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  override handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    // Upload failures are rendered beside the upload field by its component.
    if (request.url.includes('/documents')) {
      return;
    }

    if (findLimitedAvailabilityCheckoutError(response)) {
      return;
    }

    const errorMessage = response?.error?.errors?.[0]?.message ?? '';
    const productCodeMatch = errorMessage.match(/Product with code '([^']+)' not found!/);

    if (productCodeMatch) {
      return;
    }

    this.subscriptions.add(this.errorHandleService.logError(this.getErrors(response)[0]?.message).subscribe());
    this.handleBadPassword(request, response);
    this.handleBadLoginResponse(request, response);
    this.handleValidationError(request, response);
    this.handleGuestDuplicateEmail(request, response);
    this.handleUnknownIdentifierError(request, response);
  }


  override handleValidationError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => e.type === 'ValidationError')
      .forEach((error) => {
        const validationErrorReasons = genTranslationsEn.common.httpHandlers.validationErrors[error.reason as keyof object];

        if (validationErrorReasons && validationErrorReasons[error.subject as keyof object]) {
          this.globalMessageService.add({
            key: `httpHandlers.validationErrors.${error.reason}.${error.subject}`,
          },
            GlobalMessageType.MSG_TYPE_ERROR
          );
        }
      });
  }
}
